var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _path9, _g3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g4, _path18, _g5, _g6, _path19, _g7, _g8, _path20, _g9, _path21, _path22, _path23, _path24, _g10, _path25, _path26, _g11, _path27, _path28, _g12, _g13, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g14, _path40, _path41, _path42, _g15, _path43, _path44, _path45, _path46, _path47, _path48, _g16, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g17, _path59, _rect, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlumbercartoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_55",
    "data-name": "Group 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 730.035,
    height: 751.4,
    viewBox: "0 0 730.035 751.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 730.035,
    height: 751.4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 730.035,
    height: 751.399,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 158.534,
    height: 33.191,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 64.688,
    height: 71.103,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 278.602,
    height: 87.167,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 63.015,
    height: 113.271,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 20.065,
    height: 33.789,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 17.527,
    height: 32.974,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 16.778,
    height: 29.237,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 15.018,
    height: 28.515,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 61.44,
    height: 64.987,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 42.113,
    height: 42.835,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 201.256,
    height: 156.915,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 83.582,
    height: 45.445,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 28.704,
    height: 36.96,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 26.501,
    height: 30.748,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 206.429,
    height: 191.316,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 70.051,
    height: 108.967,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1079.58,766.15h-61.594a3.91,3.91,0,0,1-3.91-3.91V739.1a3.91,3.91,0,0,1,3.91-3.91h61.594a3.91,3.91,0,0,1,3.91,3.91V762.24a3.91,3.91,0,0,1-3.91,3.91",
    transform: "translate(-471.898 -342.122)",
    fill: "#edc99d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1079.833,922.488h-16.825a2.843,2.843,0,0,1-2.843-2.844V766.775h22.513V919.644a2.844,2.844,0,0,1-2.844,2.844",
    transform: "translate(-493.345 -356.818)",
    fill: "#edc99d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M913.361,956.482s-90.989-7.5-117.253,3.752-62.848,49.715-62.848,49.715l-4.69-11.256s35.645-88.175,183.853-54.406Z",
    transform: "translate(-339.039 -435.837)",
    fill: "#edc99d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M319.988,1027.7s2.814,157.589-26.265,173.535-151.96-16.885-151.96-16.885l-.938-34.707,104.121-12.194s-34.707-123.82-28.141-147.27S319.988,1027.7,319.988,1027.7",
    transform: "translate(-65.533 -458.282)",
    fill: "#2b436f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M293.715,1201.232c-29.067,15.964-151.971-16.877-151.971-16.877l-.937-34.717,15.8-1.852c.445,7.009,3.985,12.33,11.979,14.885,43.506,13.854,107.454-6.587,107.454-6.587l-31.107-18.636,42.968,10.057s8.579-51.43-13.83-73.184c-15-14.557-37.061-19.667-50.047-21.449-5.79-27.4-9.869-53.212-7.22-62.682,6.564-23.465,103.165,37.506,103.165,37.506s2.836,157.6-26.254,173.536",
    transform: "translate(-65.524 -458.283)",
    fill: "#2b436f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M281.062,894.973s-9.38,57.22,0,86.3,171.659,16.885,171.659,16.885-34.707,106.935-31.893,119.13,34.707,10.318,34.707,10.318,84.423-128.51,80.671-151.023S380.493,893.1,380.493,893.1Z",
    transform: "translate(-128.852 -415.601)",
    fill: "#2b436f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(149.873 477.5)",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M280.318,913.289c1.126-10.877,2.344-18.308,2.344-18.308l99.415-1.876s26.02,10.432,56.775,24.262c-72.363,18.917-136.1,2.977-158.534-4.079",
    transform: "translate(-280.318 -893.106)"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M456.769,1193.351s-31.9,1.875-34.717-10.314c-1.031-4.454,2.93-21.472,8.368-41.328,12.611,8.416,24.894,15.682,24.894,15.682s50.094-93.624,40.882-99.555c-9.236-5.931-42.241,6.071-42.241,6.071s-162.285,12.19-171.661-16.9a75.674,75.674,0,0,1-2.766-12.635c87.835,28.223,257.9,7.947,257.9,7.947,3.751,22.527-80.661,151.032-80.661,151.032",
    transform: "translate(-130.078 -481.343)",
    fill: "#0e2a5c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1009.261,807.683s15.947-10.318,30.955-9.38v7.5s24.389-.937,30.955,5.628.938,54.406-12.194,57.219-31.893-2.814-41.274-18.76-8.442-42.211-8.442-42.211",
    transform: "translate(-469.646 -371.461)",
    fill: "#d6916b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(539.582 426.783)",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1058.967,868.654c-13.127,2.813-31.88-2.813-41.281-18.753-9.377-15.941-8.438-42.218-8.438-42.218s15.963-10.314,30.966-9.376v7.5s1.781-.071,4.524-.047c-3,13.338-10.009,46.742-5.274,52.532,5.7,6.962,21.73-.657,28.247-49.086a11.53,11.53,0,0,1,3.446,2.227c6.563,6.564.937,54.407-12.189,57.221",
    transform: "translate(-1009.221 -798.246)"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M807.521,635.693s.291,1.492,1.045,4c3.074,10.236,13.848,37.413,43.98,49.466h186.667s46.9-11.256,46.9-60.033-259.833-16.885-259.833-16.885l-18.76,2.814Z",
    transform: "translate(-375.778 -280.14)",
    fill: "#edc99d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(431.732 321.861)",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1086.1,629.136c0,48.758-46.906,60.033-46.906,60.033H852.531a71.177,71.177,0,0,1-19.621-11.791L970,677.964l65.917-38.889H808.368c-.609-2.133-.867-3.376-.867-3.376V615.048l18.776-2.813s259.824-31.88,259.824,16.9",
    transform: "translate(-807.5 -602.002)"
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1071.893,615.544H754.03a6.161,6.161,0,0,1-6.161-6.161V572.928a6.161,6.161,0,0,1,6.161-6.161h317.863a6.161,6.161,0,0,1,6.161,6.161v36.455a6.161,6.161,0,0,1-6.161,6.161",
    transform: "translate(-348.019 -263.744)",
    fill: "#fbe2bd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M634.81,670.336S469.737,661.9,463.173,653.458c-6.587-8.462-22.527-79.748-22.527-79.748L406.89,638.432,345.92,676.9c-21.59,6.563-106.94-5.626-106.94-5.626l.938-18.753c-42.218-10.338-53.47-26.278-53.47-26.278,14.51-104.408,46.977-160.948,70.863-189.641a67.7,67.7,0,0,1,56.915-24.051l24.215,1.758,50.609,3.7s21.05,12.19,43.46,26.77c18.8,12.26,38.562,26.231,47.539,36.076,19.691,21.566,31.881,122.879,31.881,122.879l114.441,24.38c18.776,13.127,8.438,42.218,8.438,42.218",
    transform: "translate(-86.763 -191.897)",
    fill: "#2b436f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M634.81,670.756s-165.074-8.439-171.637-16.878c44.585,1.758,10.806-136.265-8.322-132.959-19.128,3.282-11.861,62.636-11.861,62.636s-.047.117-.118.328c-1.383-5.954-2.227-9.751-2.227-9.751L406.89,638.852,362.118,667.1l-7.479-19.6-92.218-53.681s-25.128-2.367-29.746,14.768c-3.844,14.322,90.952,51.1,122.481,62.893l-9.236,5.837c-21.59,6.563-106.94-5.626-106.94-5.626l.938-18.753c-42.218-10.338-53.47-26.278-53.47-26.278,18.378,16.081,83.8-68.824,93.039-136.734,5.438-40.108.07-58.837-5.228-67.441a67.956,67.956,0,0,1,26.817-9.212c-6.118,36.311,10.057,93.133,10.057,93.133l-30.99,85.045,53.4,29.02C406.07,631.023,441,516.3,441,516.3c-108.627,13.127-116.175-68.566-114.721-102.462l12.166.891,50.609,3.7s21.05,12.19,43.46,26.77c18.8,12.26,38.562,26.231,47.539,36.076,19.691,21.566,31.881,122.879,31.881,122.879s-6.986,11.7-7.642,20.933c-.562,7.876,103.165,20.136,133.1,23.488,1.243,11.392-2.579,22.176-2.579,22.176",
    transform: "translate(-86.763 -192.318)",
    fill: "#0e2a5c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M133.45,1240.24s.937,40.335-11.257,67.538l-91.926-18.76L5.878,1317.158s-15.947-14.07,4.689-42.211,23.451-60.972,28.141-59.1,21.575,14.07,21.575,14.07Z",
    transform: "translate(0 -565.759)",
    fill: "#6fca95"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M522.886,1205.391s52.53,15.008,60.972,24.389l-28.141,51.591s46.9,15.947,45.025,24.389-116.315-1.876-116.315-1.876-2.814-10.318,8.442-26.265,30.017-72.228,30.017-72.228",
    transform: "translate(-225.282 -560.927)",
    fill: "#6fca95"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M126.439,1311.312l-91.913-18.753-24.4,28.13c-5.532-14.3,13.456-44.351,24-56.892,7.712-9.142,13.291-29.888,15.753-40.413,6.539,4.219,14.651,10.08,14.651,10.08l-13.268,24.4,71.871,24.4c4.548-8.65,6.259-28.223,6.892-39.568l7.665,1.078s.938,40.342-11.252,67.535",
    transform: "translate(-4.25 -569.3)",
    fill: "#2fb266"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M600.758,1305.76c-1.9,8.439-116.316-1.876-116.316-1.876s-.844-3.093.211-8.509c50.914,14.51,70.489-66.972,70.489-66.972-12.4-8.415-27.474-11.158-36.03-12.072,2.344-6.61,3.774-10.923,3.774-10.923s52.532,15,60.971,24.379l-28.129,51.594s-11.792,9.658-12.471,13.619c-.492,2.883,36.568,6.142,56.4,7.665a3.72,3.72,0,0,1,1.1,3.094",
    transform: "translate(-225.285 -560.935)",
    fill: "#2fb266"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M552.365,770.632l-6.556-3.5-18.24,34.183-5.679,10.654a.311.311,0,0,1-.151-.009l-33.8,63.637,13.873,7.4,1.679.9,17.628-33.041,16.731-31.367,5.359-10.049,18.146-34.017Z",
    transform: "translate(-227.062 -356.986)",
    fill: "#bababa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(271.279 413.646)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M570.409,778.473l-8.992-4.8-24.38,48.043a12.178,12.178,0,0,0,3.338.883,16.723,16.723,0,0,1-3.614-.729l-14.279,27.915-15.088,29.494,3.473,6.766,1.679.9,17.628-33.041,16.247-30.46c.06.022.123.04.182.063Z",
    transform: "translate(-507.394 -773.675)"
  }))))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M567.342,719.649l11.563-20.4,12.425-3.435,4.649-1.283,3.08,3.341-12.242,11.434-.557,15.124,9.9,3.694,7.214,2.685,9.9-10.8,1.009-18.146.091-1.577,7.545,4.273,6.251,22.6L616.6,747.575l-16.769,4.68-1.268.354a12.476,12.476,0,0,1-9.1-.944L578.754,746.1a12.475,12.475,0,0,1-6.533-8.9l-.173-.976Z",
    transform: "translate(-264.011 -323.199)",
    fill: "#bababa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(314.983 371.331)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M589.693,706.816l11.779-11,4.649-1.283,3.08,3.341-12.242,11.434L596.4,724.43l9.9,3.694-.051.2-17.117-6.379Z",
    transform: "translate(-589.136 -694.53)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(339.365 378.668)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M634.74,737.195l9.9-10.8,1.009-18.146.371.206,6.251,22.6-5.761,10.164Z",
    transform: "translate(-634.74 -708.253)"
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M488.209,991.124l-9.511,17.935-10.669,3.274-3.992,1.224-2.746-2.817,10.316-10.193.114-13.1-8.66-2.956-6.308-2.149-8.3,9.584-.432,15.727-.041,1.367-6.633-3.514-5.959-19.41,9.513-17.941,14.4-4.458.433-.134a12.537,12.537,0,0,1,9.175.692l8.011,3.879a12.539,12.539,0,0,1,6.816,8.757Z",
    transform: "translate(-202.607 -448.131)",
    fill: "#bababa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(258.684 536.19)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M500.5,1021.083l-9.926,9.807-3.992,1.224-2.746-2.817,10.316-10.193.114-13.1-8.66-2.956.04-.17,14.968,5.1Z",
    transform: "translate(-483.837 -1002.877)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(239.129 531.008)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M462.279,996.388l-8.3,9.584-.433,15.727-.326-.169-5.959-19.41L452,993.185Z",
    transform: "translate(-447.261 -993.185)"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M475.927,829.52l32.539-6.525,13.511,4.319-5.829,10.645,15.811,8.5s8.812,6.863,6.175,12.137-9.889,4.615-9.889,4.615-10.208,52.39-47.628,4.768c0,0,4.965-15.452-4.69-38.459",
    transform: "translate(-221.472 -382.98)",
    fill: "#d6916b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(254.445 440.018)",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M537.347,859.825c-3.048,3.938-9.119,3.4-9.119,3.4s-5.977,30.732-25.6,23.723c20.933-27.1,4.078-29.677-3.071-29.677-5.486,0-10.432,12.283-12.494,18.26-2.04-2.18-4.2-4.688-6.446-7.548,0,0,4.946-15.448-4.712-38.467l9.236-1.852c2.907,6.868,8.064,17.675,13.1,21.379,7.572,5.6,10.22-26.043,10.22-26.043l13.5,4.313-5.837,10.643-4.383,8.111s16.244,9.7,25.6,13.76",
    transform: "translate(-475.907 -822.999)"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M286.445,734.969l26.568,6.006c4.424,1,8.846,2.015,13.277,2.982l13.273,2.955c4.43.947,8.857,1.912,13.29,2.813,4.424.959,8.859,1.827,13.289,2.7,4.436.818,8.871,1.645,13.3,2.3a125.634,125.634,0,0,0,13.121,1.506l-3.111,2.21c.166-.624.356-1.434.5-2.179q.235-1.144.411-2.311c.248-1.55.412-3.116.533-4.683a52.881,52.881,0,0,0-.163-9.357,40.552,40.552,0,0,0-1.929-8.984l-.774-2.14c-.306-.691-.644-1.365-.96-2.049l-.48-1.023-.584-.963-1.156-1.931,1.168,1.091L366.312,712.69l-19.663-11.318-9.816-5.688-9.785-5.74-19.565-11.49-2.432-1.428,1.224-2.436,10.738-21.374c3.563-7.132,7.251-14.205,10.871-21.311s7.358-14.154,11.036-21.232l5.613-10.57c1.889-3.515,3.773-7.032,5.7-10.53-1.515,3.693-3.07,7.368-4.621,11.045l-4.705,11c-3.2,7.306-6.345,14.639-9.6,21.918s-6.451,14.588-9.766,21.838l-9.9,21.776-1.207-3.864,19.832,11.022,9.913,5.516,9.883,5.569,19.733,11.2,19.683,11.284.794.456.375.635,1.387,2.355.688,1.181.57,1.237c.374.826.766,1.647,1.119,2.48l.895,2.557a46.6,46.6,0,0,1,2.119,10.489,59.466,59.466,0,0,1-.063,10.551c-.176,1.743-.4,3.479-.717,5.2q-.228,1.294-.525,2.585c-.2.879-.4,1.685-.69,2.659l-.712,2.4-2.4-.19a127.36,127.36,0,0,1-13.869-1.914c-4.517-.852-8.968-1.864-13.421-2.866-4.433-1.059-8.868-2.109-13.273-3.245-4.414-1.113-8.791-2.346-13.181-3.528-4.377-1.23-8.763-2.418-13.119-3.711-4.363-1.273-8.712-2.588-13.062-3.9-8.688-2.658-17.347-5.411-25.947-8.346",
    transform: "translate(-133.297 -274.358)",
    fill: "#172066"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M564.755,446.469c-1.922,40.483-20.066,49.555-20.066,49.555-7.923-25.48-16.713-33.4-16.713-33.4l-21.965,26.371c-34.669-25.621-35.748-62.893-35.326-73l50.61,3.7s21.05,12.19,43.46,26.77",
    transform: "translate(-219.006 -193.583)",
    fill: "#2b436f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M530.441,503.2a130.948,130.948,0,0,1,.733,23.593c-.108,1.968-.186,3.944-.359,5.906l-.545,5.892-.28,2.95-.4,2.93-.83,5.862a298.936,298.936,0,0,1-11.2,45.954l-3.89,11.172c-.631,1.868-1.382,3.691-2.12,5.519l-2.217,5.479-2.243,5.467c-.382.907-.731,1.829-1.14,2.725l-1.25,2.676q-2.488,5.358-5.04,10.68c-1.636,3.577-3.54,7.026-5.424,10.479l-5.679,10.33-.727,1.281-.779,1.253-1.557,2.5c-1.042,1.667-2.064,3.343-3.134,4.992l-3.178,4.957c-1.085,1.636-2.144,3.285-3.25,4.9.75-1.821,1.548-3.614,2.319-5.419l2.392-5.366c1.574-3.584,3.318-7.075,4.838-10.673l4.6-10.758c.759-1.794,1.552-3.571,2.334-5.352.4-.887.784-1.78,1.126-2.693l1.078-2.713q2.16-5.422,4.366-10.813l1.1-2.7c.352-.9.677-1.82,1.017-2.729l2.017-5.463,2.044-5.45c.688-1.814,1.388-3.623,1.969-5.474l3.746-11.012c4.774-14.746,9.076-29.643,12.465-44.782l1.232-5.686.618-2.845.539-2.859,1.094-5.723c.365-1.909.6-3.834.931-5.752a221.825,221.825,0,0,0,2.684-23.245",
    transform: "translate(-221.472 -234.164)",
    fill: "#172066"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M702.541,398.579c5.453,4.676,12.749,4.793,19.775,2.2,13.773-5.054,26.5-20.46,22.3-32.141-1.66-4.578-4.423-7.045-7.627-8.186-9.136-3.249-21.774,4.306-21.774,4.306s-28.8,19.982-12.669,33.822",
    transform: "translate(-324.641 -167.358)",
    fill: "#d6916b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(372.99 192.282)",
    opacity: 0.45,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M702.541,398.579c5.453,4.676,12.749,4.793,19.775,2.2-6.458-.922-9.2-3.835-4.51-7.007,6.144-4.151,21.7-11.138,21.935-17.817s-12.513-2.418-12.513-2.418c1.251-7.821,5.8-11.425,9.757-13.086-9.136-3.249-21.774,4.306-21.774,4.306s-28.8,19.982-12.669,33.822",
    transform: "translate(-697.631 -359.64)"
  }))))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M720.353,394.849a23.337,23.337,0,0,1,4.839-7.62,26.176,26.176,0,0,1,7.321-5.566,19.965,19.965,0,0,1,9.1-2.213,15.394,15.394,0,0,1,8.734,2.693,32.486,32.486,0,0,0-8.474.4,29.486,29.486,0,0,0-7.591,2.648,53.11,53.11,0,0,0-7.034,4.349c-2.293,1.648-4.537,3.43-6.9,5.309",
    transform: "translate(-335.215 -176.576)",
    fill: "#a86747"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M695.936,136.786a121.666,121.666,0,0,1-6.93,10.89,49.657,49.657,0,0,1-6.51,7.524c-17.648,16.168-194.746-87.132-194.746-87.132S503.665,24.763,534.6,1.446c0,0,32.346-4.39,62.771,2.136,1.2.262,2.394.536,3.6.83,31.423,7.732,106.73,60,118.442,79.194,0,0-1.653,4.746-4.44,11.883-4.294,11.022-11.3,27.7-19.036,41.3",
    transform: "translate(-226.974 -0.001)",
    fill: "#ffae0b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(260.777 -0.001)",
    opacity: 0.45,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M689.007,147.676a49.672,49.672,0,0,1-6.51,7.525C664.85,171.369,487.752,68.069,487.752,68.069s15.913-43.305,46.853-66.623c0,0,32.346-4.389,62.771,2.136-4.5,4.275-22.966,22.987-34.832,53.289,0,0,87.2,41.96,126.463,90.806",
    transform: "translate(-487.751 -0.001)"
  }))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M770.639,270.955s-37.824-4.232-79.565-37.872c-1.328-1.067-2.664-2.115-4.017-3.128-41.325-31.292-95.508-42.947-104.656-54.515-9.458-11.948.376-40.491.376-40.491s136.641,34.111,187.862,136",
    transform: "translate(-269.107 -62.799)",
    fill: "#ffd00d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M865.3,349.777s-37.825-4.232-79.565-37.872c-1.328-1.067-2.664-2.115-4.017-3.128,9.388-2.637,17.314-4.444,17.314-4.444s37.1,22.37,66.268,45.443",
    transform: "translate(-363.773 -141.622)",
    fill: "#ffae0b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(417.95 162.71)",
    opacity: 0.45,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M865.3,349.777s-37.825-4.232-79.565-37.872c-1.328-1.067-2.664-2.115-4.017-3.128,9.388-2.637,17.314-4.444,17.314-4.444s37.1,22.37,66.268,45.443",
    transform: "translate(-781.723 -304.332)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(417.95 162.71)",
    opacity: 0.45,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M865.3,349.777s-37.825-4.232-79.565-37.872c-1.328-1.067-2.664-2.115-4.017-3.128,9.388-2.637,17.314-4.444,17.314-4.444s37.1,22.37,66.268,45.443",
    transform: "translate(-781.723 -304.332)"
  }))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M786.121,297.707c-6.852,8.891-24.524,29.342-45.426,33.966-18.518,4.1-1.823-32.137,10.389-55.153,9.106,4.24,25.021,14.867,25.021,14.867Z",
    transform: "translate(-340.837 -128.679)",
    fill: "#2b251b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M537.2,167.107l-63.144,50.968L463.15,175.85l2.54-9.576,1.415-5.335.789-2.951,3.72-14.029,4.689-17.652c20.484-4.115,52.9,4.079,52.9,4.079l2.339,10.756,2.578,11.835.533,2.4,1.873,8.606Z",
    transform: "translate(-215.526 -58.239)",
    fill: "#2b251b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M472.023,171.6l3.72-14.029c32.144,5.807,57.791-3.165,57.791-3.165l2.137.35,2.578,11.834c-1.461.607-3.293,1.431-5.562,2.5-20.792,9.809-49.422,5-60.664,2.509",
    transform: "translate(-219.655 -71.854)",
    fill: "#493e2e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M538.737,190.3a62.505,62.505,0,0,1-17.642,7.266c-22.849,5.882-44.247-1.226-53.193-4.978l1.414-5.335c26.541,9.283,55.132,2.754,55.132,2.754s7.5-4.726,12.415-8.313Z",
    transform: "translate(-217.737 -84.55)",
    fill: "#493e2e"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M449.194,268.31c-19.515.429-23.289-13.938-20.238-27.137,2.687-11.653,10.688-22.407,17.844-21.268a22.176,22.176,0,0,1,12.27,6.031,24.819,24.819,0,0,1,5.461,8.106,19.136,19.136,0,0,1,.912,2.633s20.5,30.83-16.249,31.634",
    transform: "translate(-199.176 -102.295)",
    fill: "#d6916b"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M650.787,225.505l-3.615,4.1-2.859,3.251-19.272,21.938-9.664,11-13.34,39.7-8.056,23.958S442.4,340.934,465.536,228.812l15.338-34.267,1-2.248s42.692-18.278,47.318-57.353c0,0,6.116,26.988,31.918,41.252s68.076,33.991,89.674,49.31",
    transform: "translate(-215.518 -62.796)",
    fill: "#d6916b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M538.033,323.391c-1.559.282-2.861.462-4.123.664s-2.425.393-3.576.636-2.3.476-3.508.82c-.626.125-1.224.345-1.9.5a21.935,21.935,0,0,1-2.159.512,7.7,7.7,0,0,1,2.6-3.752,9.452,9.452,0,0,1,4.191-1.95,9.8,9.8,0,0,1,4.6.151,7.439,7.439,0,0,1,3.876,2.421",
    transform: "translate(-243.267 -149.199)",
    fill: "#a86747"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M552.274,398.112c-14.8-7.787-17.623-19.611-17.132-28.769a39.383,39.383,0,0,1,3.162-13.492s13.2,13.55,13.124,14.13c-.063.491,27.279,8.9,35.123,11.3,1.3.407,2.077.637,2.077.637s-9.146,30.521-36.354,16.2",
    transform: "translate(-249.003 -165.595)",
    fill: "#100e14"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M580.418,388.963c-22.263,8.042-39.4-11.633-45.232-19.62a39.382,39.382,0,0,1,3.162-13.492s13.2,13.55,13.124,14.13c-.062.491,27.279,8.9,35.123,11.3.886,3.047-.747,5.719-6.177,7.685",
    transform: "translate(-249.048 -165.595)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M599.3,384.234c-45.068-16.268-60.314-33.288-65.167-44.7-4.072-9.577-1.3-15.989-1.182-16.258l3.606,1.611-1.8-.806,1.809.791c-.091.213-2.19,5.322,1.3,13.34,4.631,10.635,19.28,26.608,62.777,42.308Z",
    transform: "translate(-247.526 -150.436)",
    fill: "#a86747"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M615.385,409.9c-31.1-8.806-77.144-42.049-77.144-42.049,21.543-10.188,38.728-1.509,38.728-1.509,7.676,20.761,27.2,19.879,27.2,19.879a23.325,23.325,0,0,1,4.417,4.668c4.152,5.708,5.811,12.695,6.446,16.4.279,1.618.351,2.616.351,2.616",
    transform: "translate(-250.469 -168.872)",
    fill: "#2b251b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(307.618 138.683)",
    opacity: 0.45,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M602.2,282.839c-3.91,9.829-12.668,15.572-19.561,12.83s-9.312-12.933-5.4-22.761,12.668-15.572,19.561-12.829,9.312,12.933,5.4,22.76",
    transform: "translate(-575.362 -259.392)"
  }))))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M598.846,295.035c-2.586,6.5-8.378,10.3-12.937,8.485s-6.159-8.553-3.573-15.053,8.379-10.3,12.938-8.485,6.159,8.553,3.573,15.053",
    transform: "translate(-270.413 -130.079)",
    fill: "#1b1723"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M595.154,289.523c-.812,2.04-2.629,3.232-4.06,2.663s-1.933-2.684-1.121-4.724,2.629-3.233,4.06-2.663,1.933,2.684,1.121,4.724",
    transform: "translate(-274.362 -132.465)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M597.266,301.855c-.411,1.033-1.331,1.637-2.056,1.348s-.979-1.359-.568-2.392,1.331-1.637,2.056-1.348.979,1.359.568,2.392",
    transform: "translate(-276.624 -139.322)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(366.915 169.805)",
    opacity: 0.45,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M709.382,339.181c-4.886,7.767-13.264,11.285-18.711,7.858s-5.9-12.5-1.016-20.269,13.263-11.284,18.711-7.857,5.9,12.5,1.016,20.268",
    transform: "translate(-686.268 -317.6)"
  }))))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M705.756,348.273c-3.231,5.137-8.772,7.463-12.375,5.2s-3.9-8.268-.672-13.405,8.772-7.463,12.375-5.2,3.9,8.268.673,13.4",
    transform: "translate(-321.308 -155.427)",
    fill: "#1b1723"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M705.027,341.942c-1.014,1.612-2.753,2.343-3.884,1.631s-1.225-2.6-.211-4.207,2.753-2.342,3.884-1.631,1.225,2.6.211,4.207",
    transform: "translate(-325.85 -157.038)",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M705.233,352.558c-.513.816-1.394,1.186-1.966.825a1.557,1.557,0,0,1-.107-2.13c.514-.816,1.394-1.186,1.966-.826a1.556,1.556,0,0,1,.107,2.13",
    transform: "translate(-327.048 -163.007)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M625.838,228.6a137.568,137.568,0,0,1-23.514-2.835c-1.282-.258-2.473-.516-3.562-.768a24.658,24.658,0,0,1-6.18-2.331,11.523,11.523,0,0,1-1.031-.583,22.559,22.559,0,0,1-3.9-2.913c-.386-.341-.761-.705-1.117-1.076a18.308,18.308,0,0,1,2.654-3.982,19.623,19.623,0,0,1,12.318-6.8,20.479,20.479,0,0,1,2.09-.2,25.468,25.468,0,0,1,5.508.35,19.569,19.569,0,0,1,6.028,1.97c10.664,5.547,10.7,19.162,10.7,19.162",
    transform: "translate(-272.942 -96.368)",
    fill: "#2b251b"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M592.524,222.276a22.554,22.554,0,0,1-3.9-2.913,36.31,36.31,0,0,1,1.537-5.057,19.618,19.618,0,0,1,12.318-6.8c-4.16,3.538-8.329,8.526-9.956,14.768",
    transform: "translate(-273.915 -96.564)",
    fill: "#493e2e"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M620.4,209.435a74.035,74.035,0,0,0-12.809,16.328c-1.282-.258-2.473-.516-3.563-.768a24.655,24.655,0,0,1-6.18-2.331,36.519,36.519,0,0,1,11.015-15.549,25.463,25.463,0,0,1,5.508.35,19.573,19.573,0,0,1,6.028,1.97",
    transform: "translate(-278.206 -96.368)",
    fill: "#493e2e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(228.84 72.145)",
    opacity: 0.45,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M573.73,325.527c-2.465.266-138.218,14.557-124.536-96.715-19.515.429-23.289-13.938-20.238-27.137,3.151,5.984,8.907,15.022,15.53,16.646,0,0-11.39-11.4-2.726-22.026,4.841-5.927,11.614-8.257,17.31-9.857a24.825,24.825,0,0,1,5.461,8.106l1-2.248s42.692-18.278,47.318-57.353c0,0,6.116,26.988,31.917,41.252s68.076,33.991,89.675,49.31l-3.615,4.1c-12.694-10.1-60.654-45.544-97.939-50.445C489.735,173.5,398.169,326.25,573.73,325.527",
    transform: "translate(-428.016 -134.941)"
  }))))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M708.5,419.373c-8.63-5.984-17.892-14.23-16.428-21.341,2.668-12.925,29.768-18.356,29.768-18.356Z",
    transform: "translate(-321.983 -176.682)",
    fill: "#efae8e"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M750.755,288.552,731.483,310.49c-15.956-17.925-48.13-55.558-37.5-55.859,11.283-.317,44.5,24.447,56.775,33.92",
    transform: "translate(-321.961 -118.491)",
    fill: "#efae8e"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M723.352,275.929a129.51,129.51,0,0,0,11.012,19.365c.69,1.018,1.347,1.957,1.963,2.811a23.2,23.2,0,0,0,4.269,4.512,10.734,10.734,0,0,0,.882.682,21.175,21.175,0,0,0,3.945,2.322c.436.212.889.4,1.34.578a17.24,17.24,0,0,0,2.488-3.751,18.452,18.452,0,0,0,1.415-13.157,19.152,19.152,0,0,0-.589-1.886,23.968,23.968,0,0,0-2.307-4.65,18.41,18.41,0,0,0-3.9-4.512c-8.69-7.232-20.515-2.315-20.515-2.315",
    transform: "translate(-336.61 -127.644)",
    fill: "#2b251b"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M757.253,316.351a21.178,21.178,0,0,0,3.945,2.322,34.223,34.223,0,0,0,3.828-3.172,18.452,18.452,0,0,0,1.415-13.157c-1.556,4.895-4.365,10.325-9.188,14.007",
    transform: "translate(-352.386 -140.696)",
    fill: "#493e2e"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M753.451,281.679a69.626,69.626,0,0,1-9.5,17.05c.69,1.018,1.347,1.957,1.963,2.811a23.208,23.208,0,0,0,4.269,4.512,34.348,34.348,0,0,0,9.48-15.21,23.965,23.965,0,0,0-2.307-4.65,18.423,18.423,0,0,0-3.9-4.512",
    transform: "translate(-346.195 -131.079)",
    fill: "#493e2e"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M644.579,362.215s-9.2-3.3-13.3.391,19.031,21.813,26.01,18.844-6.174-17.779-12.706-19.235",
    transform: "translate(-293.537 -167.926)",
    fill: "#efae8e"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M638.563,419.817c-12.4-.207-48.168-23.59-48.168-23.59l1.837-2.21-3.429.892c1.913-3.516,7.654-5.079,7.654-5.079,17.309,16.1,31.994,14.354,35.66,13.592,4.153,5.708,5.811,12.7,6.446,16.4",
    transform: "translate(-273.999 -181.407)",
    fill: "#493e2e"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M639.452,349.094q-.922,2.049-1.907,4.061c-.643,1.349-1.316,2.68-1.988,4.011l-.381-1.186a36.015,36.015,0,0,1,4.519,2.011,34.46,34.46,0,0,1,4.257,2.588,22.738,22.738,0,0,1,3.841,3.4,12.952,12.952,0,0,1,2.783,4.716,9.26,9.26,0,0,1,.436,2.919,8.948,8.948,0,0,1-.149,1.491c-.049.244-.083.495-.149.732l-.22.7a9.969,9.969,0,0,1-.563,1.342,14.074,14.074,0,0,1-.793,1.3c-.315.4-.655.777-1,1.143-.377.319-.747.666-1.145.948a14,14,0,0,1-5.147,2.143,22.226,22.226,0,0,1-5.256.375,27.1,27.1,0,0,1-5.095-.7,31.07,31.07,0,0,1-4.852-1.542,33.629,33.629,0,0,1-4.527-2.282,30.474,30.474,0,0,1-4.07-3.01c-.645-.543-1.23-1.159-1.826-1.75-.549-.644-1.134-1.247-1.624-1.937a23.52,23.52,0,0,1-2.646-4.266,21.758,21.758,0,0,1-2.066-9.559,24.673,24.673,0,0,0,9.986,15.245,31.479,31.479,0,0,0,3.876,2.4,32.753,32.753,0,0,0,4.18,1.8,29.674,29.674,0,0,0,4.364,1.192,25.011,25.011,0,0,0,4.437.51c2.919.09,5.934-.373,8.022-1.8.26-.173.476-.382.724-.563.2-.215.406-.429.6-.648.148-.253.333-.458.476-.739a7.089,7.089,0,0,0,.393-.863,5.683,5.683,0,0,0,.218-3.6,10.111,10.111,0,0,0-1.865-3.628,22.473,22.473,0,0,0-3.1-3.242,44.775,44.775,0,0,0-7.678-5.3l-.874-.489.493-.7c.862-1.217,1.724-2.435,2.616-3.634s1.777-2.4,2.7-3.585",
    transform: "translate(-283.807 -162.451)",
    fill: "#a86747"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M465.293,266.308c.015-3.008.017-5.865-.151-8.661a39.957,39.957,0,0,0-1.22-8.051,20.713,20.713,0,0,0-3.387-7.03c-.379-.548-.842-1.026-1.276-1.553-.488-.464-.938-1-1.478-1.437a42.354,42.354,0,0,0-3.4-2.721,14,14,0,0,1,4.433,1.075,13.566,13.566,0,0,1,3.984,2.506,16.63,16.63,0,0,1,4.932,8.106,23.14,23.14,0,0,1,.506,9.241,22.4,22.4,0,0,1-2.941,8.523",
    transform: "translate(-211.444 -110.221)",
    fill: "#a86747"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M704.66,115.87s4.174,2.171,10.588,5.7c12.726,7,34.287,19.378,49.359,30.743,0,0,33.99-43.758,34.78-75.543,0,0-15.755-17.5-46.632-33.421l-8.809.788S726.159,96.58,704.66,115.87",
    transform: "translate(-327.912 -20.171)",
    fill: "#ffd00d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(376.748 23.171)",
    opacity: 0.45,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M704.66,115.87s4.174,2.171,10.588,5.7c12.726,7,34.287,19.378,49.359,30.743,0,0,4.415-5.691,10.1-14.47-8.715-6.42-22.845-19.105-20.948-32.9,1.927-14.037,10.049-39.28,14.573-52.7-4.676-2.946-9.868-5.947-15.581-8.9l-8.809.788S726.159,96.58,704.66,115.87",
    transform: "translate(-704.66 -43.342)"
  }))))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M704.66,115.87s4.174,2.171,10.588,5.7l.428-.445c41.648-45.309,37.079-77.775,37.079-77.775l-8.809.788S726.159,96.58,704.66,115.87",
    transform: "translate(-327.912 -20.171)",
    fill: "#ffae0b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 14.503,
    height: 29.432,
    transform: "translate(628.16 133.221)",
    fill: "#90a4ae"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M1204.937,299.639v25.236a1.876,1.876,0,0,1-1.877,1.876H1100.732a6.767,6.767,0,0,0-6.769,6.764v11.729a1.876,1.876,0,0,1-1.877,1.876h-25.253a1.876,1.876,0,0,1-1.877-1.876V326.751a29,29,0,0,1,29.008-28.988h109.1a1.877,1.877,0,0,1,1.877,1.876",
    transform: "translate(-495.575 -138.564)",
    fill: "#90a4ae"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M1092.085,358.745v13.6h12.626a1.876,1.876,0,0,0,1.877-1.876V358.745a6.766,6.766,0,0,1,6.769-6.764h-14.5a6.766,6.766,0,0,0-6.769,6.764",
    transform: "translate(-508.199 -163.794)",
    fill: "#78909c"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M1299.646,297.764v28.988h12.626a1.876,1.876,0,0,0,1.877-1.876V299.64a1.876,1.876,0,0,0-1.877-1.876h-12.626Z",
    transform: "translate(-604.788 -138.564)",
    fill: "#78909c"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M1179.917,328.933h-22.306a12.053,12.053,0,0,1-12.053-12.053V297.5a12.053,12.053,0,0,1,12.053-12.053h22.306A12.053,12.053,0,0,1,1191.97,297.5V316.88a12.053,12.053,0,0,1-12.053,12.053",
    transform: "translate(-533.083 -132.835)",
    fill: "#78909c"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M1197.191,285.452h-14.5a12.054,12.054,0,0,1,12.057,12.049v19.383a12.054,12.054,0,0,1-12.057,12.049h14.5a12.053,12.053,0,0,0,12.057-12.049V297.5a12.053,12.053,0,0,0-12.057-12.049",
    transform: "translate(-550.361 -132.835)",
    fill: "#607d8b"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M1130.9,239.416h-16.556a9.61,9.61,0,0,1-9.61-9.61V229.7a9.61,9.61,0,0,1,9.61-9.61H1130.9a9.61,9.61,0,0,1,9.61,9.61v.105a9.61,9.61,0,0,1-9.61,9.61",
    transform: "translate(-514.087 -102.419)",
    fill: "#90a4ae"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1232.163,239.416h-16.557a9.61,9.61,0,0,1-9.61-9.61V229.7a9.61,9.61,0,0,1,9.61-9.61h16.556a9.61,9.61,0,0,1,9.61,9.61v.105a9.609,9.609,0,0,1-9.609,9.61",
    transform: "translate(-561.208 -102.419)",
    fill: "#90a4ae"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1242.307,220.091h-14.5a9.61,9.61,0,0,1,9.613,9.607v.112a9.61,9.61,0,0,1-9.613,9.607h14.5a9.61,9.61,0,0,0,9.613-9.607V229.7a9.61,9.61,0,0,0-9.613-9.607",
    transform: "translate(-571.356 -102.419)",
    fill: "#78909c"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1177.6,239.716h-3.885a13.044,13.044,0,0,1,0-26.089h3.885a13.044,13.044,0,0,1,0,26.089",
    transform: "translate(-540.116 -99.411)",
    fill: "#78909c"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M1184.324,213.626h-3.868a13.009,13.009,0,0,0-5.318,1.133,13.04,13.04,0,0,1,0,23.824,13.017,13.017,0,0,0,5.318,1.132h3.868a13.044,13.044,0,1,0,0-26.089",
    transform: "translate(-546.848 -99.411)",
    fill: "#607d8b"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M1096.869,460.212c0,15.209-8.658,20.5-19.338,20.5s-19.338-5.293-19.338-20.5c0-12.885,13.879-28.753,18.121-33.3a1.663,1.663,0,0,1,2.434,0c4.242,4.549,18.121,20.417,18.121,33.3",
    transform: "translate(-492.427 -198.416)",
    fill: "#8cf2ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbercartoon);
export default __webpack_public_path__ + "static/media/plumbercartoon.909aee7bb45d1bef37fc327cd29f12b9.svg";
export { ForwardRef as ReactComponent };